import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Avatar,
  Typography
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const ConfirmDialog = ({
  open,
  title = "Confirm Delete",
  content = "Are you sure you want to delete this item? This action cannot be undone.",
  cancelText = "Cancel",
  confirmText = "Delete",
  onClose,
  onConfirm,
  confirmColor = "error",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: '20px',
          padding: { xs: '24px 16px', sm: '32px 24px' },
          minWidth: { xs: '320px', sm: '420px' },
          maxWidth: '420px',
          textAlign: 'center',
          boxShadow: '0px 8px 32px rgba(0,0,0,0.08)',
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <Avatar
          sx={{
            bgcolor: 'rgba(239, 68, 68, 0.1)',
            color: '#ef4444',
            width: 64,
            height: 64,
          }}
        >
          <WarningAmberIcon sx={{ fontSize: 32 }} />
        </Avatar>
      </Box>

      <DialogTitle id="confirm-dialog-title" sx={{ fontWeight: 600, fontSize: '1.25rem', color: '#1e293b', p: 0, mb: 1.5 }}>
        {title}
      </DialogTitle>
      
      <DialogContent sx={{ p: 0, mb: 4 }}>
        <DialogContentText id="confirm-dialog-description" sx={{ color: '#64748b', fontSize: '0.95rem', lineHeight: 1.5 }}>
          {content}
        </DialogContentText>
      </DialogContent>
      
      <DialogActions sx={{ p: 0, display: 'flex', gap: 2 }}>
        <Button 
          onClick={onClose} 
          variant="outlined" 
          sx={{ 
            flex: 1, 
            fontWeight: 600, 
            borderRadius: '10px', 
            textTransform: 'none',
            color: '#475569',
            borderColor: '#cbd5e1',
            py: 1.2,
            '&:hover': {
              borderColor: '#94a3b8',
              bgcolor: '#f8fafc'
            }
          }}
        >
          {cancelText}
        </Button>
        <Button 
          onClick={() => {
            onConfirm();
            onClose();
          }} 
          color={confirmColor} 
          variant="contained" 
          autoFocus
          disableElevation
          sx={{ 
            flex: 1, 
            fontWeight: 600, 
            borderRadius: '10px',
            textTransform: 'none',
            py: 1.2,
            bgcolor: confirmColor === 'error' ? '#ef4444' : undefined,
            '&:hover': {
              bgcolor: confirmColor === 'error' ? '#dc2626' : undefined,
            }
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
